import React from 'react';

const Helpers = {

	getUrlVars: function(){
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	},
	getUrlVar: function(name){
		if(this.getUrlVars().hasOwnProperty(name)) {
			return this.getUrlVars()[name];
		}
		else {
			return false;
		}
	},
	write: function(word,number) {
		if(number===1) {
			return word+"en";
		}
		else {
			return word
		}
	},

	o2a: function(obj) {
		const object = obj;
		const keys = Object.keys(object);
		let items = [];
		Object.keys(object).map((key, i) => (
			items.push(object[key])
		))
		return {
			keys: keys,
			items: items
		}
	},

	tsnds: function(number) {
		let output = number;

		if(isNaN(number)) {
			return number;
		}

		let absolute = Math.abs(number);
		
		if(absolute>=10000) {

			let minus = "";
			if(number<0) {
				minus = "-";
			}

			absolute = absolute.toString();

			let parts = absolute.split(".");
			let front = parts[0];
			let back = parts[1];
			
			let tsdA = [];
			let splits=Math.ceil(front.length/3)-1;
			
			for(let i=splits;i>=0;i--) {
				let f=3*i;
				let ar=front.substring(front.length-f,front.length-f-3);
				tsdA.push(ar);
			}
			const tsdS=tsdA.join("'");
			output = minus+tsdS;
			if(back*1>0) {
				output = output+"."+back;
			}
		}
		return output;
	},
	

	string2date: function(str) {
		str = str.replace(/-/g, "/");
		let output = str;

		if(str.length>1) {
			if(new Date(str)) {
				output = new Date(str)
			}
			else {
				output = "";
			}
		}
		else {
			output = str
		}
		return output
	},

	formatDate: function(date,format) {
		//console.log(date)
		const month_names = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"]
		const month_names_short = ["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"]
		const month_names_short_FR = ["Jan","Feb","Mar","Apr","May","Juin","Jul","Aug","Sep","Oct","Nov","Dec"]

		const leading_zero = (number) => {
			if(number*1<10) {
				return "0"+number
			}
			else return number
		}

		let output = String(date);
		if(String(date).length>1) {
			switch(format) {
				case "D. M. YYYY": 
					output = date.getDate()+ ". " + (date.getMonth()+1) + ". " + date.getFullYear()
				break;					
				case "D. Mon.": 
				output = date.getDate()+ ". " + month_names_short[date.getMonth()] + ". "
				break;				
				case "D. Month YYYY": 
					output = date.getDate()+ ". " + month_names[date.getMonth()] + " " +date.getFullYear()
				break;						
				case "D. Month YYYY HH:MM": 
					output = date.getDate()+ ". " + month_names[date.getMonth()] + " " +date.getFullYear() + "  " + leading_zero(date.getHours()) + ":" + leading_zero(date.getMinutes())
				break;					
				case "D. M. HH:MM": 
					output = date.getDate()+ ". " + (date.getMonth()+1) +".  " + leading_zero(date.getHours()) + ":" + leading_zero(date.getMinutes())
				break;
				case "D. Mon. YYYY HH:MM": 
				output = date.getDate()+ ". " + month_names_short[date.getMonth()] + ". " +date.getFullYear() + "  " + leading_zero(date.getHours()) + ":" + leading_zero(date.getMinutes())
				break;
				case "D. Mon. YYYY HH:MM fr": 
				output = date.getDate()+ ". " + month_names_short_FR[date.getMonth()] + ". " +date.getFullYear() + "  " + leading_zero(date.getHours()) + ":" + leading_zero(date.getMinutes())
			
				break;	
				case "D. Month HH:MM": 
				output = date.getDate()+ ". " + month_names[date.getMonth()] + " " + leading_zero(date.getHours()) + ":" + leading_zero(date.getMinutes())
				break;				
				case "D. Month": 
					output = date.getDate()+ ". " + month_names[date.getMonth()]
				break;				
				case "D. Mon YYYY": 
					output = date.getDate()+ ". " + month_names_short[date.getMonth()] + " " +date.getFullYear()
				break;

				default : 
					output = date.getDate()+ ". " + (date.getMonth()+1) + ". " + date.getFullYear()
				break;

			}			
		}
		return output
	},

	write_date(str,format) {
		let d = this.string2date(str);
		return(this.formatDate(d,format));
	},

	sorting: function(data,by,direction) {
		let local = JSON.parse(JSON.stringify(data)); // Deep Copy
		function sortNow(a,b) {
			let returner = 0;
			let a1 = a[by];
			let b1 = b[by];

			if(isNaN(a1) || isNaN(b1)) {
				a1 = a1.toString();
				b1 = b1.toString();
			}
			else {
				a1 = a1*1;
				b1 = b1*1;
			}

			if(a1>b1) {
				returner = 1*direction
			}
			else if(a1<b1) {
				returner = -1*direction
			}
			else {
				returner = 0;
			}
			return returner;

		}
		local.sort(sortNow);
		return local;
	},


	renderNotes: function(notes) {
		if(notes.length>0) {
			return(
				<ul className='noteList'>
					{
						notes.map((note, k) => {
							return (
								<li className = 'noteListItem' key = {k}>
									<small>
										{ note	}
									</small>									
								</li>
							)
						})
					}
				</ul>
			)
		}
	},

	renderOver: function(over) {
		if(over===true) {
			return(" ✓")
		}
		else {
			return ("")
		}
	},

	rephraser(str) {
		const dictionnary = {
			"Democratic Party": "Demokraten",
			"Republican Party": "Republikaner"
		}
		if(dictionnary.hasOwnProperty(str)) {
			return (dictionnary[str])
		}
		else return(str)
	},

	getPercent(total,part) {
		let output = 0;
		if(total>0 && part>0) {
			output = Math.floor(part/total*100*100)/100;
		}
		return (output)
	},

	update_trigger_specific(current,next,triggers) {
		let triggered = false;
		if(triggers!==undefined) {
			triggers.map((trigger,k) => {
				if(next.hasOwnProperty(trigger) && current.hasOwnProperty(trigger)) {
					if(current[trigger] !== next[trigger]) {
						triggered = true;
					}
				}
				return false;
			})
		}
		return triggered;
	},

	update_trigger(current,next) {
		let triggered = false;
		Object.keys(current).map((key, i) => {
			if(current[key]!==next[key]) {
				triggered = true;
			}
			return false;
		})
		return triggered;
	},

	convertHexColor(hexCode,opacity){
		var hex = hexCode.replace('#','');
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}
	
		var r = parseInt(hex.substring(0,2), 16),
			g = parseInt(hex.substring(2,4), 16),
			b = parseInt(hex.substring(4,6), 16);
	
		return 'rgba('+r+','+g+','+b+','+opacity/100+')';
	},

	shuffleArray(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
		return array;
	},

	sortingObjectToArray: function(data,by,direction) {
        // let local = JSON.parse(JSON.stringify(data)); // Deep Copy
        let local = [];
        Object.keys(data).map(function(key, index) {
            local.push(data[key])
			return false;
        })      
        local.sort(sortNow);
        
        function sortNow(a,b) {
            let returner = 0;
            let a1 = a[by];
            let b1 = b[by];

            if(a1 && b1) {
                if(isNaN(a1) || isNaN(b1)) {
                    a1 = a1.toString().toLowerCase();
                    b1 = b1.toString().toLowerCase();
                }
                else {
                    a1 = a1*1;
                    b1 = b1*1;
                }
            }
            if(a1>b1) {
                returner = 1*direction
            }
            else if(a1<b1) {
                returner = -1*direction
            }
            else {
                returner = 0;
            }
            return returner;

        }       
        return local;
    },




}


export default Helpers;

